import React from 'react'
import { observer } from 'mobx-react'
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps'
import withScriptjs from 'react-google-maps/lib/async/withScriptjs'

import MarkerClusterer from 'react-google-maps/lib/addons/MarkerClusterer'
import { MUSEUM_ICON } from '../icons'

const svgString = `<svg width="40" height="40" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
   <path
    d="${MUSEUM_ICON.path}"
    fill="${MUSEUM_ICON.fillColor}"
    fill-opacity="${MUSEUM_ICON.fillOpacity}"
    transform="scale(${MUSEUM_ICON.scale})"
    stroke-color="${MUSEUM_ICON.strokeColor}"
    stroke-weight="${MUSEUM_ICON.strokeWeight}"
   />
</svg>`

const imagePath = (`data:image/svg+xml;base64,${btoa(svgString)}`)

const Map = withScriptjs(withGoogleMap(observer((props) => {

  /* eslint-disable no-unused-vars */
  const {
    center,
    onMapLoad,
    onMapClick,
    markers,
    onMarkerClick,
    onMarkerClose,
    mapOpts
  } = props
  /* eslint-enable no-unused-vars */

  if (!mapOpts) {
    return null
  }

  return (
    <GoogleMap
      ref={onMapLoad}
      defaultZoom={3}
      defaultCenter={mapOpts.center}
      onClick={onMapClick}
      {...mapOpts}
      defaultOptions={mapOpts}
    >
      <MarkerClusterer
        averageCenter
        enableRetinaIcons
        maxZoom={12}
        styles={[
          {
            width: 20,
            height: 20,
            url: imagePath,
            textColor: 'white',
            textSize: 12,
            backgroundColor: MUSEUM_ICON.fillColor,
            borderRadius: '10px',
            border: '1px solid white',
            left: '20px'
          }
        ]}
        zoomOnClick
        clustererClass="marker-clusterer"
      >
        {markers.map((marker) => (

          <Marker
            key={marker.id}
            {...marker}
            onClick={() => onMarkerClick(marker)}
          >
            {marker.showInfo
              ? marker.renderInfoContent(marker, props.onMarkerClose)
              : null}
          </Marker>
        ))}
      </MarkerClusterer>
    </GoogleMap>
  )

})))

export { Map as default }



// WEBPACK FOOTER //
// ./src/frontend/map/components/Map.js